import { Component, createRef } from 'react';
import { PersonCallLogGrid } from '~/components/person-call-log-grid/person-call-log-grid';

export class CallLogs extends Component {
  constructor(props) {
    super(props);

    this.windowResized = this.windowResized.bind(this);
    this.personCallLogGridRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.windowResized);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResized);
  }

  windowResized() {
    this.personCallLogGridRef.setgridHeight();
  }

  render() {
    return (
      <>
        <div className="title">
          <span>Call Logs</span>
        </div>
        <PersonCallLogGrid
          ref={this.personCallLogGridRef}
        />
      </>
    );
  }
}
